import { config } from "../../../config";
import { uuidv4 } from "../../../utils/uuid";
import yup, { yupUUID } from "../../../utils/yup";

import type { UnlayerDesign } from "../../unlayer-email-content/types/unlayer-design";

export const emailMomentSchemaShape = {
  id: yupUUID.default(() => uuidv4()),
  from_address: yup
    .string()
    .required("Please enter a from address.")
    .default(config.defaultEmailFrom),
  subject: yup.string().required("Enter a subject for the email").ensure(),
  body: yup.string(),
  design: yup.object().required("Enter a body for the email"),
  newDesign: yup.boolean().default(false).isFalse("Enter a body for the email"),
};
const emailMomentSchema = yup.object(emailMomentSchemaShape);

export interface EmailMoment extends Omit<
  Omit<yup.InferType<typeof emailMomentSchema>, "design">,
  "newDesign"
> {
  design: UnlayerDesign | null | undefined;
  newDesign: boolean;
}
